import {showNotification} from 'platform/components';

import {removeProperties} from 'shared/web';

import {GridApi} from '../types/AgGridTypes';

// We want to exclude certain fields from validation because they will never have a corresponding column in the DG
const VALIDATION_EXCEPTION = ['searchType'];

/**
 * Validates the keys of the external filter values to ensure that each key corresponds to a defined column in the Grid API.
 * If a key does not correspond to any defined column, an error notification is shown.
 */
export const validateExternalFiltersKeys = (
  newFilterValues: Record<string, unknown>,
  api: GridApi
) => {
  const filteredValues = removeProperties(newFilterValues, VALIDATION_EXCEPTION);

  Object.keys(filteredValues).forEach((key: string) => {
    const column = api.getColumn(key);
    if (column) {
      return;
    }

    return showNotification.error(`Column not defined ${key}`);
  });
};
